import wdk from 'wikidata-sdk';
import config from './config';

const parseWikidata = function (data, langs) {
  const list = [].concat(data);
  return [].concat(wdk.getManyEntities(list, langs || config.langs));
};

export { parseWikidata as parse, parseWikidata as default };